var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0C5.59126 0 0 5.59063 0 12.5C0 19.4086 5.59063 25 12.5 25C19.4087 25 25 19.4094 25 12.5C25 5.59136 19.4094 0 12.5 0ZM12.5 23.2558C6.56924 23.2558 1.74419 18.4308 1.74419 12.5C1.74419 6.56919 6.56924 1.74419 12.5 1.74419C18.4308 1.74419 23.2558 6.56919 23.2558 12.5C23.2558 18.4308 18.4308 23.2558 12.5 23.2558Z",
    fill: "#2A73FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5003 10.4198C11.7599 10.4198 11.2334 10.7325 11.2334 11.1932V17.462C11.2334 17.857 11.7599 18.2518 12.5003 18.2518C13.2079 18.2518 13.7837 17.857 13.7837 17.462V11.1931C13.7837 10.7324 13.2079 10.4198 12.5003 10.4198Z",
    fill: "#2A73FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5003 6.5531C11.7434 6.5531 11.1511 7.09607 11.1511 7.72131C11.1511 8.34661 11.7435 8.90603 12.5003 8.90603C13.2407 8.90603 13.8331 8.34661 13.8331 7.72131C13.8331 7.09607 13.2407 6.5531 12.5003 6.5531Z",
    fill: "#2A73FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoBlue);
export default __webpack_public_path__ + "static/media/info_blue.d26658f121fd160b803f425bf915446a.svg";
export { ForwardRef as ReactComponent };